import React from 'react';
import PureComponent from 'components/PureComponent';
import Share from 'components/Share';
import WaveLink from 'components/WaveLink';

import mm from './mm.png';
import bp from './bp.svg';
import br from './br.png';

class Footer extends PureComponent {

	render() {
		require('./Footer.styl');

		return (
			<footer className="Footer">

				<a href="/files/bottles.pdf" target="_blank">Глубинная вода Байкальская</a>

				<div className="Footer__brands">
					<a href="http://baikalpearl.com/" target="_blank">
						<img src={bp} width="94" height="31" />
					</a>

					<a href="http://baikal-sea.com/zapovednik/" target="_blank">
						<img src={br} width="81" height="30" />
					</a>
				</div>
			</footer>
		);
				// <a href="http://medvedevmarketing.ru" target="_blank" className="Footer__copyright">
				// 	<span>Создание сайта:</span>
				// 	<img src={mm} width="146" height="19" />
				// </a>
	}

}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js